export default __webpack_public_path__ + "static/media/save.7503c569.mp3";